<template>
  <li class="profile-nav onhover-dropdown pe-0 py-0">
    <div class="media profile-media">
      <img
        class="b-r-10"
        :src="admin.profile_img ? $image_url + admin.profile_img : require('@/assets/images/dashboard/no-user.jpg')"
        alt="Profile"
        style="width: 40px; height: 40px; object-fit: cover; border-radius: 50%;"
      />
      <div class="media-body" style="margin-top: 6px;">
        <span style="color: white; font-weight: bold;">{{ admin.name }}<i class="middle fa fa-angle-down"></i></span>
      </div>
    </div>
    <ul class="profile-dropdown onhover-show-div" style="width: 400px;">
     
      <!-- <li>
        <i class="fa fa-gear"></i> <router-link :to="{ name: 'settings' }">Settings</router-link>
      </li> -->
      <li>
        <a @click="logout"
          ><vue-feather type="log-in"></vue-feather><span>Log out</span></a
        >
      </li>
    </ul>
  </li>
</template>

<script>

  export default {
    name: 'Profile',
    data() {
			return {
        user: {},
        user_name: "",

        admin: {},
      }
    },
    created() {
      this.getToken(); // Get user data from localStorage first
			this.fetchProfile();
		},
    methods: {

      getToken() {
        if (localStorage.getItem('airotrack_staff')) {
          var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff'));
          if(airotrack_staff.token) {

            this.token = airotrack_staff.token;
            this.user = airotrack_staff;
            
          } else {
            this.$swal("", "Failed to fetch token, please login again", "error");
            this.$router.push({ name: "login" });
          }

        } else {
          this.$swal("", "Session expired, please login again", "error");
          this.$router.push({ name: "login" });
        }
      }, 

      fetchProfile(page_url = null) {
				this.getToken();
				let url = "staffs/settings";
				page_url = page_url || url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						this.admin = responseData.admin;
			console.log(this.admin);
					})
					.catch((err) => console.log(err));
			},

      logout() {
        let url = "staffs/logout";         
        this.getToken();
        this.loading = true;
        this.$axios
        .get(url, { headers: { Authorization: "Bearer " + this.token } })
        .then((res) => {
          console.log(res);
          var responseData = res.data.data;
          console.log(responseData);

          if(localStorage.getItem('airotrack_staff')) {
            localStorage.removeItem("airotrack_staff");    
          }         
          this.$swal("", "You have been successfully logged out", "success");
          this.$router.push({ name: "Login" });
        })
        .catch((error) => {
          if (error.response) {
            if(error.response.status == 422) {               
              if (error.response.data) {
                this.errors = error.response.data.message;
              } 
              this.$swal("", error.response.statusText, "error");
                        
            } else if(error.response.status == 500) {
              this.$swal("", error.response.statusText, "error");
                        
            } else {
              this.$swal("", "Something went wrong", "error");
            }
          } else {
            this.$swal("", error.message, "error");
          }
        })
        .finally(() => (this.loading = false));
      },

    },
  };
</script>
